import { RootState } from '../../../types/redux/states/RootState';
import { websitesApiEndpoints } from '../websitesApiEndpoints/websitesApiEndpoints';
import { fetchQuery } from './fetchQuery';
import type { BaseQueryFn } from '@reduxjs/toolkit/dist/query/baseQueryTypes';
import { getVentureId } from '../../selectors/getVentureId';
import { getResellerId } from '../../selectors/getResellerId';
import { uuid } from '../../../utils/uuid';

export function gemFetchQuery({ basePath }: { basePath: string }): BaseQueryFn {
  return async (args, api, extraOptions) => {
    const state = api.getState() as RootState;
    const ventureId = getVentureId(state);
    const resellerId = getResellerId(state);
    const requestId = uuid();

    // NOTE: Is there any other way to get the accountId for the current website?
    // TODO: Move accountId back to Slice????
    const currentWebsite = await api.dispatch(
      websitesApiEndpoints.endpoints.fetchVentureWebsite.initiate({ ventureId })
    );

    return fetchQuery({
      basePath,
      subDomain: resellerId === 1 ? 'gem' : 'emailmarketing',
      prepareHeaders: async (headers: Headers) => {
        headers.set('Accept', 'application/json');
        headers.set('Content-Type', 'application/json');
        if (currentWebsite?.data?.id) {
          headers.set('X-WebsiteId', currentWebsite?.data?.id);
        }

        if (currentWebsite?.data?.accountId) {
          headers.set('X-AccountId', currentWebsite?.data?.accountId);
        }
        headers.set('X-RequestId', requestId);
      }
    })(args, api, extraOptions);
  };
}
